import React, { useEffect } from 'react';
import EstimateGrid from '../../../features/cfi/estimate-grid/components/EstimateGrid';
import { useTitle } from "../../../contexts/title";

export default function LeadsPage() {

	const pageTitle = useTitle();
	useEffect(() => {
		pageTitle.setTitle('Leads')
	}, [pageTitle]);

	return (
		<React.Fragment>
			<div className={'content-block'}>
				<EstimateGrid leads={true} />
			</div>
		</React.Fragment>
	)
} 
